import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscriber } from 'rxjs/Subscriber';
import { PremisesService, ApiService, ContractService, SupportDataService } from '../../_services';
import { IPremises, IContract, IChangeCallback, IIdName } from '../../_entities';
import { IDataAccessEvent, CrudOperation } from "../../_entities/data";
import { ContractBase } from "./contract.base";

@Component({
	selector: 'contract-simplified',
	template: require('./contract-simplified.template.html')
})
export class ContractSimplifiedComponent extends ContractBase implements OnInit {

	private onContractChangedEvent: Subscriber<IDataAccessEvent<IContract>>;

	@Input() disabled: boolean = false;

	@Output() contractChanged = new EventEmitter();

	_allowLease: boolean = true;

	@Input("allowLease")
	set allowLease(value: boolean) {
		this._allowLease = value;
	}

	contractStatuses: Promise<IIdName[]>;

	constructor(
		private readonly router: Router,
		private readonly route: ActivatedRoute,
		private readonly supportData: SupportDataService,
		private readonly premisesService: PremisesService,
		protected readonly contractService: ContractService,
		private api: ApiService) {

		super(contractService);

		this.contractStatuses = supportData.getContractStatuses();

		this.onContractChangedEvent =
			this.contractService.itemChanged.subscribe(
				(evt: IDataAccessEvent<IContract>) => this.onContractChange(evt));
	}

	onContractChange(evt: IDataAccessEvent<IContract>) {
		if (evt.operation === CrudOperation.Create || evt.operation === CrudOperation.Delete) {
			this.router.navigate(["contracts"], { relativeTo: this.route.parent });
		}

		this.contractChanged.emit();
	}

	getPremisesDetails(): Promise<IPremises> {
		return this.premisesService.getPremises(this.store.premisesId);
	}


	get rentAndCharges() {
		if (this.contract)
			return this.contract.rentAndCharges;

		return null;
	}

	get termPossession() {
		if (this.contract)
			return this.contract.termPossession;

		return null;
	}

	ngOnInit(): void {
		this.api.profile.get().then(p => this.userProfile = p);
		this.supportData.contractTypes.then(result => this._contractTypes = result);
	}

	ngOnDestroy(): void {
	}

	userProfile;

	_contractTypes: IIdName[] = [];

	get contractTypes(): IIdName[] {
		if (this._allowLease)
			return this._contractTypes;

		return this._contractTypes.filter(x => x.id !== 1);

	}

	rentChargesTypes =
		[
			{ id: "straight-rent", name: "Simple" },
			{ id: "area-based", name: "Area-based" },
			{ id: "time-based", name: "Time-based" },
			{ id: "occurance-based", name: "Occurance-based" }
		];



	public onFollow(event: IChangeCallback<any>, projectId: number) {
		const index = this.userProfile.myContracts.indexOf(projectId, 0);

		if (index == -1) {
			this.userProfile.myContracts.push(projectId);
		}

		this.api.profile.save(this.userProfile).then(p => {
			this.userProfile = p;
			event.resolve();
		}, error => {
			event.reject(error);
		});
	}

	public onUnFollow(event: IChangeCallback<any>, projectId: number) {
		const index = this.userProfile.myContracts.indexOf(projectId, 0);
		if (index > -1) {
			this.userProfile.myContracts.splice(index, 1);
		}

		this.api.profile.save(this.userProfile).then(p => {
			this.userProfile = p;
			event.resolve();
		},
			error => {
				event.reject(error);
			});

	}
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-simplified.component.ts